import { render, staticRenderFns } from "./ProductPage2.vue?vue&type=template&id=66aee122&scoped=true"
import script from "./ProductPage2.vue?vue&type=script&lang=js"
export * from "./ProductPage2.vue?vue&type=script&lang=js"
import style0 from "./ProductPage2.vue?vue&type=style&index=0&id=66aee122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aee122",
  null
  
)

export default component.exports